import { makeAutoObservable, runInAction } from "mobx";

import { StockistIssue } from "../../../Common/DTOs/StockistIssue";
import { issueAjaxController } from "../../../Common/Ajax/IssueAjaxController";

class TextualIssueOutletController {
  private _issues: StockistIssue[] = [];
  private _isLoadingUpcomingIssues = false;

  get issues() {
    return this._issues;
  }

  get isLoadingUpcomingIssues() {
    return this._isLoadingUpcomingIssues;
  }

  set isLoadingUpcomingIssues(value: boolean) {
    this._isLoadingUpcomingIssues = value;
  }

  constructor() {
    makeAutoObservable(this);
  }

  async getUpcomingIssues() {
    this.isLoadingUpcomingIssues = true;
    const issues = await issueAjaxController.getUpcomingIssues();

    runInAction(() => {
      this.isLoadingUpcomingIssues = false;
      this._issues = issues;
    });
  }

  async searchUpcomingIssues(searchText: string) {
    this.isLoadingUpcomingIssues = true;
    const issues = searchText.length > 0 ? await issueAjaxController.searchUpcomingIssues(searchText) : await issueAjaxController.getUpcomingIssues();

    runInAction(() => {
      this.isLoadingUpcomingIssues = false;
      this._issues = issues;
    });

  }
  
  private daysUntil(date: Date): number {
    const now = new Date();
    const diff = (new Date(date).getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
    return Math.ceil(diff);
  }

  get upcomingWeekIssues() {
    return this._issues.filter(i => {
      const days = this.daysUntil(i.issueOnSale);
      return days >= 0 && days <= 7;
    });
  }

  get upcomingMonthIssues() {
    return this._issues.filter(i => {
      const days = this.daysUntil(i.issueOnSale);
      return days > 7 && days <= 60;
    });
  }
}

export const textualIssueOutletController = new TextualIssueOutletController();